<template>
  <div class="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <v-tab-bar v-if="$route.meta.isshowtabbar" ref="bar"></v-tab-bar>
    <FloatingIcon v-if="!$route.meta.hideFloatingService" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import tabBar from './components/common/Tabbar'
import * as api from '@/api/api'
import FloatingIcon from '@/components/common/FloatingIcon.vue'

export default {
  name: 'app',
  computed: {
    ...mapState({
      isOnline: (state) => state.auth.isOnline
    })
  },
  created: function () {
    this.qcellcore()
    if (this.isOnline) {
      this.fetchCartCount()
    }
    this.saveAuthInfo()

    let name = this.$route.name
    if (name) {
      this.changeTabBar(name)
    }
    this.toggleFloatingService(!!this.$route.meta.hideFloatingService)
  },
  beforeDestroy() {
    this.toggleFloatingService(false)
  },
  watch: {
    $route(to, from) {
      // 路由改变发起重置
      this.resetStates()
      this.changeTabBar(to.name)
      this.toggleFloatingService(!!to.meta.hideFloatingService)
    },
    isOnline(val) {
      if (val) {
        this.fetchCartCount()
      } else {
        this.setCartNumber(0)
      }
    }
  },
  methods: {
    ...mapMutations({
      saveToken: 'saveToken',
      clearToken: 'clearToken',
      changeTabBar: 'changeTabBar',
      setCartNumber: 'setCartNumber'
    }),
    ...mapActions({
      resetStates: 'resetStates',
      fetchCartCount: 'fetchCartCount'
    }),
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    saveAuthInfo() {
      let location = window.location
      let references = this.utils.getUrlKey(location.href, 'u')
      if (references) {
        this.$cookie.set('r', references)
      }
      let token = this.utils.getUrlKey(location.href, 'token')
      if (token) {
        this.$cookie.set('t', token)
        this.saveToken({ token: token })
      }
    },
    qcellcore() {
      if (process.env.NODE_ENV === 'development') return
      const nation = ['中国', '马来西亚', '新加坡']
      api.getClientIp().then(res => {
        if (!nation.includes(res.country)) {
          window.location.href = 'https://men.solarbio.com/#/home'
        }
      })
    },
    toggleFloatingService(hide) {
      document.body.classList.toggle('hide-floating-service', hide)
      if (this._qidianHideTimer) {
        clearInterval(this._qidianHideTimer)
        this._qidianHideTimer = null
      }
      if (hide) {
        this.hideQidianWidget()
        this._qidianHideTimer = setInterval(() => this.hideQidianWidget(), 500)
      }
    },
    hideQidianWidget() {
      document.querySelectorAll('[id*="qidian"], iframe[src*="qiye.qq.com"]').forEach((el) => {
        el.style.setProperty('display', 'none', 'important')
      })
    }
  },
  components: {
    'v-tab-bar': tabBar,
    FloatingIcon
  }
}
</script>

<style>
div.app {
  height: 100%;
  background-color: #fff;
}

body.hide-floating-service [id*="qidian"],
body.hide-floating-service iframe[src*="qiye.qq.com"] {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue